import React from "react";
import Reveal from "../../components/Reveal";
import FuturaHero from "../../components/cases/FuturaHero";
import CaseArticleFutura from "../../components/cases/CaseArticleFutura";
import Footer from "../Footer";
import ContactCta from "../main_page/ContactCta";

export default function FuturaCasePage() {
  return (
    <div className="case-detail-page">
      <Reveal as="section" variant="fade" threshold={0.15}>
        <FuturaHero />
      </Reveal>

      <CaseArticleFutura/>

      <Reveal as="section" variant="zoom" delay={0.08}>
        <ContactCta />
      </Reveal>

      <Footer />
    </div>
  );
}